import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';

import { ModifierTypes } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnInit {
  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() layoutMod: ModifierTypes[] = [];

  layoutModifier = '';

  control!: AbstractControl | null;

  constructor(
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.control = this.mainForm.get(this.controlName);
    this.layoutModifier = this.stylingService.concatLayoutModifiers('textareaField', this.layoutMod);
  }
}
